var gbis = {
    menuOpen: false,
    isNvbq: $('body').hasClass('designNewBank2022'),
    is2018: $('body').hasClass('design2018'),
    is2015: $('body').hasClass('design2015'),
    isHamburgermenu: $('body').hasClass('hamburgermenu'),
    isTransparentHeader: $('body').hasClass('transparentHeader'),
    isTransparentHeaderImmersive: $('body').hasClass('transparentHeader_immersive'),
    initLogoWhite: $('body').hasClass('logoWhite'),
    isOnePageMenu: $('body').hasClass('hasOnePageMenu'),
    isHeaderOneLine: $('body').hasClass('headerOneLine'),
    enabledFixedSideBar: gbisIsEnabledFixedSideBar()
};


/**
 * permet de desactiviter le fait de désactiver la side bar fixée
 * On va gérer nos cas spéciaux ici, afin d'éviter d'ajouter des fonctionnalité de contribution dans le backend
 * @returns {boolean}
 */
function gbisIsEnabledFixedSideBar(){
    // on désactive sur la page 6075 à cause d'un powermail en mode step / step
    // TODO convergence : cet id n'est que pour AFRIQUE, pas grave car la page est supprimé sur GBIS
    // mais si on rajoute des exceptions, il faudrait distinguer afrique / gbis
    if($('body').hasClass('page6075')){
        return false;
    }
    // pas de side bar fixé sur mobile
    if(isMobile()){
        return false;
    }
    return true
}

var pistilMainMenu = (function() {

    function init() {

        $('.mainContainer .mainMenu > li').mouseenter(function() {
            $(this).addClass("hover");
        }).mouseleave(function() {
            $(this).removeClass("hover");
        });

        $('.mainContainer .mainMenu > li').focusin(function() {
            $('.mainContainer .mainMenu > li').removeClass('hover');
            $(this).addClass("hover");
        });

        $('#langueSwitcherForm').focusin(function(){
            $('.mainContainer .mainMenu > li').removeClass('hover');
        })



        $( '.mainContainer .mainMenu > li > a' ).doubleTapToGo();

        $('.navmobileMenu .mainMenu > li > a').on( 'click', function(){

            if($(this).next().length){
                if (!$(this).parent('li').hasClass('active')){
                    $('.navmobileMenu .mainMenuSub').slideUp();
                    $(this).next().slideToggle();
                    $('.navmobileMenu > ul > li').removeClass('active');
                    $(this).parent('li').addClass('active');
                } else {
                    $(this).next().slideUp();
                    $(this).parent('li').removeClass('active');
                }
                return false;
            }
        } );


        // gestion du menu oneLine
        if(gbis.isHeaderOneLine){
            $('.mainMenuOneLine > li').attr('aria-expanded', false);
            $('.mainMenuOneLine > li').mouseenter(function() {
                $(this).attr('aria-expanded', true);
                $(this).siblings().attr('aria-expanded', false);
            });
            $('.mainMenuOneLine > li').mouseleave(function() {
               $(this).attr('aria-expanded', false);
            });
        }



    }

    return { init : init };

})();


(function() {
    // trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
    if (!String.prototype.trim) {
        (function() {
            // Make sure we trim BOM and NBSP
            var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            String.prototype.trim = function() {
                return this.replace(rtrim, '');
            };
        })();
    }

    $('input.input__field').each(function(){
        if($(this).val() !== ''){
            $(this).parent().addClass( 'input--filled' );
        }
        this.addEventListener( 'focus', onInputFocus );
        this.addEventListener( 'blur', onInputBlur );
    });

    function onInputFocus( ev ) {
        classie.add( ev.target.parentNode, 'input--filled' );
    }

    function onInputBlur( ev ) {
        if( ev.target.value.trim() === '' ) {
            classie.remove( ev.target.parentNode, 'input--filled' );
        }
    }
})();



/**
 * Permet de rediriger des url ave des tracking XITI en url avec tracké UTM
 */
function redirectXitiInUtm(){

    var myUrl = document.location.href;

    if(myUrl && myUrl.indexOf("#xtor") >= 0){

        var re = /(htt.*:\/\/[^#]*)#xtor=([^\[]*)-\[([^\]]*)\]-([0-9]*)-\[([^\]]*)]/i;
        var urlSplit = myUrl.match(re);
        if(urlSplit != null){
            console.debug('Url xtor finded');
            var newUrl =  urlSplit[1]+"?utm_source="+urlSplit[2]+"&utm_medium="+urlSplit[3]+"&utm_term="+urlSplit[4]+"&utm_content="+encodeURIComponent(urlSplit[5]);
            document.location.href = newUrl;
        }
    }


}


/**
 *
 * @param val
 * @returns {boolean}
 */
function changeHeaderLogo(val){

    console.debug('changeHeaderLogo', val);

    if(gbis.is2015) return false;
    if($('body').hasClass('navOpen')) return false;

    if(val == 'white'){
        $('body').addClass('logoWhite');
    } else if(val == 'black'){
        $('body').removeClass('logoWhite');
    } else {
        if(gbis.initLogoWhite){
            $('body').addClass('logoWhite');
        } else {
            $('body').removeClass('logoWhite');
        }
    }
}


function isZoomed(){
    if($('body').css('font-size') == '14px'){
        return false;
    } else {
        return true;
    }
}


/**
 * [gaTrackPage description]
 * @param  {[type]} url [description]
 * @return {[type]}     [description]
 */
function gaTrackPage(url){
    if(typeof(ga) == "undefined") return;
    ga('send', 'pageview', url);
    if( typeof gaT2 != undefined){
        ga('t2.send', 'pageview', url);
    }
}

/**
 * [gaTrackButtonEvent description]
 * @param  {[type]} type  [description]
 * @param  {[type]} label [description]
 * @return {[type]}       [description]
 */
function gaTrackButtonEvent(label, type){
    if(typeof(ga) == "undefined") return;
    if(type == undefined) type = 'button';
    ga('send', 'event', type, 'click', label);
    if( typeof gaT2 != undefined){
        ga('t2.send', 'event', type, 'click', label);
    }
}


/**
 * [gaTrackEvent description]
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
function gaTrackEvent(options){
    if(typeof(ga) == "undefined") return;
    ga('send', options);
    if( typeof gaT2 != undefined){
        ga('t2.send', options);
    }
}


function haveCss(){
    if($('#nocss').css('display') == 'none'){
        return true;
    } else {
        return false;
    }
}

function viewportSize(){
    var test = document.createElement( "div" );
    test.style.cssText = "position: fixed;top: 0;left: 0;bottom: 0;right: 0;";
    document.documentElement.insertBefore( test, document.documentElement.firstChild );
    var dims = { width: test.offsetWidth, height: test.offsetHeight };
    document.documentElement.removeChild( test );
    return dims;
}



function isIE() {
    var myNav = navigator.userAgent.toLowerCase();
    return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
}



function initAddthisGaEvents(cssSelector){
    $(cssSelector).each(function(){
        $(this).click(function(){
            var rs = $(this).find('.accessi').html();
            gaTrackEvent({
                hitType: 'event',
                eventCategory: 'button',
                eventAction: rs,
                eventLabel: $(document).attr('title')
            })
        })
    });
}


function initCardsGaEvents(){
    $('.tx-dce-pi1 .card, .tx-bisgsummary-pi3 .card').each(function(){
        $(this).click(function(){
            if($(this).data('href')){
                gaTrackEvent({
                    hitType: 'event',
                    eventCategory: 'button',
                    eventAction:  'wall block',
                    eventLabel: $(this).data('href')
                })
            }
        })
    });
}



function initVideoGaEvents(){

    $('.videoPlayer video').on('play', function(){
        gaTrackEvent({
            hitType: 'event',
            eventCategory: 'Player video',
            eventAction:  'play',
            eventLabel: $(this).data('src')
        })
    });
}

function initImportFundsGaEvents() {
   $('.importFunds-kiids a').on('click', function(){

       var label = $(this).attr('href');

       gaTrackEvent({
           hitType: 'event',
           eventCategory: 'button',
           eventAction: 'click',
           eventLabel: label
       })
   })
}

function initDceGaEvents(){

    $('.dce-btn a').on('click', function(){

        var action = $(this).find('.dce-button__label').html();
        var label = $(this).attr('href');

        gaTrackEvent({
            hitType: 'event',
            eventCategory: 'button',
            eventAction: action,
            eventLabel: label
        })

        $(this).addClass('gaEvent');

    });


    $('.dce-parallaxeVideo a').on('click', function(){

        var action = $(this).html();
        var label = $(this).attr('href');

        gaTrackEvent({
            hitType: 'event',
            eventCategory: 'button',
            eventAction: action,
            eventLabel: label
        })

        $(this).addClass('gaEvent');

    });

    $('a.dce-button, .dce-button a, .tx-dce-pi1 .parallax .cta').on('click', function(){

        var action = $(this).html();
        var label = $(this).attr('href');

        gaTrackEvent({
            hitType: 'event',
            eventCategory: 'button',
            eventAction: action,
            eventLabel: label
        });

        $(this).addClass('gaEvent');

    });




}


function initContentsAssets(){
    $('.tx-biimgcarrousel-pi1 .square, .gridder .itemContent').forceSquare();
    $('.carrouselCard, .cardItem, .card').sggbisCard();
}



function isMobile(){
    if($(document).width() < 768){
        return true;
    } else {
        return false;
    }
}
function isTabletV(){
    if($(document).width() >= 768 && $(document).width() < 992){
        return true;
    } else {
        return false;
    }
}


/**
 * [strip_tags description]
 * @param  {[type]} input   [description]
 * @param  {[type]} allowed [description]
 * @return {[type]}         [description]
 */
function strip_tags(input, allowed) {

    allowed = (((allowed || '') + '')
        .toLowerCase()
        .match(/<[a-z][a-z0-9]*>/g) || [])
        .join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
    var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
        commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
    return input.replace(commentsAndPhpTags, '')
        .replace(tags, function($0, $1) {
            return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
        });
}

if (!Array.prototype.indexOf)
{
    Array.prototype.indexOf = function(elt /*, from*/)
    {
        var len = this.length >>> 0;

        var from = Number(arguments[1]) || 0;
        from = (from < 0)
            ? Math.ceil(from)
            : Math.floor(from);
        if (from < 0)
            from += len;

        for (; from < len; from++)
        {
            if (from in this &&
                this[from] === elt)
                return from;
        }
        return -1;
    };
}

function scrollToItem($item){
    console.debug('scrollToItem', $item);
    var speed = 750;
    var offSet = 0;
    if($('.fixedheader.active').length){
        offSet = $('.fixedheader.active').height() + 150;
    }

    $('html, body').animate( { scrollTop: $item.offset().top - offSet }, speed );
}


/**
 * Permet de simuler l'écriture d'un texte dans un div
 * @param item selector css
 * @param text texte à faire apparaitre
 * @param i 0
 * @constructor
 */
function SG_typeText(item, text, i) {

    var delay = _.random(1, 10)*20;

    $(item).append(text.charAt(i))
        .delay(delay)
        .promise()
        .done(function() {
            if(i<text.length) {
                i++;
                SG_typeText(item, text, i);
            }
        });
}



function SG_debounce(func, wait, immediate) {
    var timeout;
    return function() {
        console.debug('SG_debounce')
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

/**
 * Permet d'ajouter une entrée dans le log via une requette AJAX
 * @param category
 * @param datas
 * @constructor
 */
function SG_addlog(category, datas){
    $.post( "/?eID=Gbis::AddLog", {
        category: category, myDatas: datas
    }).done(function( data ) {
        //alert( "Data Loaded: " + data );
    });
}


function initTracking(){

    if(GBIS.tracking.pageType){

        let pageType = GBIS.tracking.pageType;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'pageview',
            'pageType' : pageType,
            'pageName' : document.title
        });
    }




}

